import { Component, OnDestroy } from '@angular/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { AlertController, AlertInput, LoadingController, MenuController, ModalController, NavController, Platform } from '@ionic/angular';
import { FirebaseService } from './services/firebase.service';
import { Insomnia } from '@ionic-native/insomnia/ngx';
import { AlertService } from './services/alert.service';
import { UbicacionService } from './services/ubicacion.service';
import { AuthService } from './services/auth.service';
import { RedatwaterService } from './services/redatwater.service';
import { TranslateConfigService } from './services/translate-config.service';
import { AppCajerosAguaComponent } from './components/app/app-cajeros-agua/app-cajeros-agua.component';
import { AquabotService } from './services/aquabot.service';
import { AppGuiarapidaComponent } from './components/app/app-guiarapida/app-guiarapida.component';
import { AppUsabilidadComponent } from './components/app/app-usabilidad/app-usabilidad.component';
import { AppUsabilidadService } from './services/app-usabilidad.service';
import { HelpComponent } from './components/app/aquabot/help/help.component';
import { AppRegistroComponent } from './components/app/app-registro/app-registro.component';
import { AppPubliaquaYoutubeComponent } from './components/tvbox/app-publiaqua-youtube/app-publiaqua-youtube.component';
import { EscanerService } from './services/escaner.service';
import { NotificacionesService } from './services/notificaciones.service';
import { VersionesServices } from './services/versiones.services';
import { AppInteresComponent } from './components/app/app-interes/app-interes.component';
import { TextSpeechService } from './services/text-speech.service';
import { ApadrinamientoModalComponent } from './components/app/apadrinamiento-modal/apadrinamiento-modal.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnDestroy {

  channelSistema: any = null;
  channelApp: any = null;
  authDispositivo: any = null;
  videoComofunciona: string = 'https://www.youtube.com/watch?v=fmRQ1OMCx1c';

  private reloadIntervalId: any;
  private timeoutId: any;
  private isPromptActive = false;

  ubicacion: any = {
    direccion: null,
    lat: null,
    lng: null
  }

  private moduloSeleccionado: any;

  motivoSeleccionado: string = '';
  motivosContacto: string[] = [
    'Recargar Saldo',
    'Olvidé mi contraseña',
    'Asesoría general'
  ];

  aquahabiente: any = {
    codigo: null,
    clave: null,
    encriptado: 1
  }

  authAdmin: any = null;

  pedidoDomiciliario: any = {
    sistema_key: '',
    pedido_id: '',
    encriptado: 1
  };

  paisSeleccionado: any = null;

  imgSistema = '';
  precioActualLitroSistema = 0;
  coberturaCajerosATWATER: boolean = false;
  cajerosCercanos: any = null;

  idiomaSeleccionado: string = null;
  selectedLanguage: string;
  itemsIdiomaApp: any = [];
  itemsIdioma: any = [];
  idiomaPagina = 'APP';

  aquaBot: any = {
    guia_referencia: '',
    msg: '',
    estado: ''
  };

  constructor(
    private versionesService: VersionesServices,
    private platform: Platform,
    private notificacion: NotificacionesService,
    private menu: MenuController,
    private translateConfigService: TranslateConfigService,
    private redatwater: RedatwaterService,
    private auth: AuthService,
    private escaner: EscanerService,
    private alertCtr: AlertController,
    private aquabot: AquabotService,
    private appUbicacion: UbicacionService,
    private appUsabilidad: AppUsabilidadService,
    private modalController: ModalController,
    public navCtrl: NavController,
    private insomnia: Insomnia,
    private textSpeech: TextSpeechService,
    public ventanaAlerta: AlertService
  ) {
    // console.log('Iniciando componentes...');
    this.initializeApp();
    this.notificacion.inicializar();
    this.conexionRedATWATER();
    this.checkAppVersion();
    this.recargarWebView();
  }

  ngOnDestroy() {
    if (this.reloadIntervalId) {
      clearInterval(this.reloadIntervalId);
      clearInterval(this.timeoutId);
    }
  }

  async checkAppVersion() {
    try {
      const { isUpdateAvailable, currentVersion, officialVersion, mensaje } =
        await this.versionesService.checkForUpdate();

      if (isUpdateAvailable) {
        // Alerta obligatoria para actualizar
        const alert = await this.alertCtr.create({
          header: 'Actualización requerida',
          message: `
            <span class="text-success">Nueva versión disponible: ${officialVersion}.</span><br>
            Tu versión actual es ${currentVersion}.<br><br>
            <strong>Es necesario actualizar la app para continuar usándola.</strong>`,
          backdropDismiss: false, // Bloquea cierre accidental de la alerta
          buttons: [
            {
              text: 'Actualizar ahora',
              handler: () => {
                window.open('https://bancodelagua.com/app/es/homepage/descargarAppPlaystore?tipo_app=atwater', '_system');
              }
            },
          ],
        });

        await alert.present();

        // Bloquea la ejecución de la app
        return; // Asegura que no continúe si la app necesita actualizarse
      } else {
        console.log(mensaje || 'La app está actualizada.');
      }
    } catch (error) {
      console.error('Error al verificar la versión de la app:', error);
      this.showAlert('Error', 'No se pudo verificar la versión de la app.');
    }
  }


  async showAlert(header: string, message: string) {
    const alert = await this.alertCtr.create({
      header,
      message,
      buttons: ['OK'],
    });
    await alert.present();
  }

  async conexionRedATWATER() {

    this.translateConfigService.initAppIdioma().then((dataIdioma: any) => {
      this.translateConfigService.itemsIdiomaPagina(this.idiomaPagina).then((dataPagina: any) => {
        this.itemsIdiomaApp = this.translateConfigService.getItemsIdiomaApp();
        this.itemsIdioma = this.translateConfigService.getItemsIdioma();
        this.translateConfigService.getItemsIdioma();
        this.idiomaSeleccionado = this.translateConfigService.getDefaultLanguage();

        //console.log('Idioma seleccionado -> ', this.idiomaSeleccionado);


        if (this.itemsIdiomaApp && this.itemsIdioma) {

          this.auth.getAuthDispositivoObservable().subscribe(async (getDispositivo: any) => {
            //console.log('Dispositivo Auth ->', getDispositivo);
            if (getDispositivo) {

              //console.log('Parametros de idioma App -> ', this.itemsIdiomaApp);
              //console.log('Parametros de idioma -> ', this.itemsIdioma);
              //console.log('Test 1 -> ', this.itemsIdiomaApp.app_loading);
              this.authDispositivo = getDispositivo;

              if (this.authDispositivo?.usuario_auth) {
                // console.log('Usuario App logueado  -> ', this.authDispositivo.usuario_auth);

              }


              this.redatwater.getDataSistema(this.authDispositivo.sistema_id).then((getData: any) => {
                // console.log('Seguimiento -> Datos de sistema: ', getData);
                if (getData) {
                  if (getData?.channel_app[0].channel_sistema) {
                    this.channelApp = getData.channel_app;
                    this.channelSistema = getData?.channel_app[0].channel_sistema;

                    this.videoComofunciona = this.channelSistema.modelo_video_comofunciona;

                    this.auth.loadAppConfig().then((getApp: any) => {
                      if (getApp?.pais) {
                        // console.log('Seguimiento -> Establecer Sesion pais: ', getApp);
                        this.paisSeleccionado = {
                          id: getApp.pais_id,
                          indicativo_movil: '',
                          pais: getApp.pais,
                          divisa: getApp.divisa,
                          idioma: '',
                          continente: '',
                          precio_litro_agua: '',
                        }
                      } else {
                        console.log('Seguimiento de errores -> ', getApp);
                      }
                    }).catch((err: any) => {
                      console.log('Seguimiento de errores -> ', err);
                      if (this.authDispositivo?.usuario_auth) {
                        if (this.authDispositivo.usuario_auth?.pais) {
                          this.paisSeleccionado = {
                            id: this.authDispositivo?.usuario_auth.pais,
                            indicativo_movil: this.authDispositivo?.usuario_auth.pais_indicativo_movil,
                            pais: this.authDispositivo?.usuario_auth.pais_id,
                            divisa: this.authDispositivo?.usuario_auth.pais_divisa,
                            idioma: this.authDispositivo?.usuario_auth.pais_idioma_id,
                            continente: '',
                            precio_litro_agua: this.authDispositivo?.usuario_auth.pais_precio_litro_agua,
                          }
                          this.redatwater.setPaisSeleccionado(this.paisSeleccionado);
                        }
                      }
                    });

                    if (this.channelSistema?.contacto.litro_agua) {
                      this.precioActualLitroSistema = this.channelSistema.contacto.litro_agua;
                      // console.log('Seguimiento -> Precio de litro de agua: ', this.precioActualLitroSistema);
                    }
                    if (this.channelApp[0].lista_cobertura_cajeros_atwater) { // COBERTURA CAJEROS DE AGUA
                      // console.log('Seguimiento -> Cobertura de cajeros de agua: *************', this.channelApp[0].lista_cobertura_cajeros_atwater);
                      this.cajerosCercanos = this.channelApp[0].lista_cobertura_cajeros_atwater;
                      this.coberturaCajerosATWATER = true;
                    }
                    this.imgSistema = 'assets/img/sistemas/' + this.channelSistema.modelo_id + '.png';



                  } else {
                    console.log('Seguimiento de errores -> Datos de sistema:  ', getData);
                  }
                } else {
                  console.log('Seguimiento de errores -> Datos de sistema:  ', getData);
                }
              }).catch((err: any) => {
                console.log('Seguimiento de errores -> ', err);
              });

            }
          });

        } else {
          this.translateConfigService.resetIdioma(this.idiomaPagina);
        }
      }).catch((err: any) => {
        console.log('Seguimiento de errores -> ', err);
      });
    }).catch((err: any) => {
      console.log('Seguimiento de errores -> ', err);
    });


  }

  seleccionarIdioma(idioma) {
    if (idioma) {
      //console.log('Seleccionar idioma -> ', idioma);
      this.selectedLanguage = idioma;
      //console.log('Idioma seleccionado: ' + this.selectedLanguage);
      this.languageChanged(this.selectedLanguage);
      this.idiomaSeleccionado = idioma;

      this.translateConfigService.initAppIdioma().then((dataIdioma: any) => {
        this.translateConfigService.itemsIdiomaPagina(this.idiomaPagina).then((dataPagina: any) => {
          this.itemsIdiomaApp = this.translateConfigService.getItemsIdiomaApp();
          this.itemsIdioma = this.translateConfigService.getItemsIdioma();
          this.translateConfigService.getItemsIdioma();
          if (this.itemsIdiomaApp && this.itemsIdioma) {
            //console.log('Parametros de idioma App -> ', this.itemsIdiomaApp);
            //console.log('Parametros de idioma -> ', this.itemsIdioma);
            //console.log('Test 2 -> ', this.itemsIdiomaApp.app_loading);

          } else {
            this.translateConfigService.resetIdioma(this.idiomaPagina);
          }
        }).catch((err: any) => {
          console.log('Seguimiento de errores -> ', err);
        });
      }).catch((err: any) => {
        console.log('Seguimiento de errores -> ', err);
      });
    }
  }

  languageChanged(idioma: string) {
    this.translateConfigService.setLanguage(idioma);
  }


  /* Nav Asistencia */
  navAsistencia() {
    this.menu.close('custom');
    this.aquabot.enlaceSugerido(this.redatwater.getWebUrl() + '/' + this.idiomaSeleccionado + '/homepage/chat', 'sitio oficial');
  }

  navAsesoria() {
    this.contactoOpciones();
  }

  contactoOpciones() {
    console.log('Opciones de Contacto!');
    this.viewOpcionesContacto();
  }

  async viewOpcionesContacto() {
    const inputs: AlertInput[] = this.motivosContacto.map((motivo) => ({
      name: 'motivo',
      type: 'radio', // Especificamos correctamente el tipo
      label: motivo,
      value: motivo,
      checked: false // Opcional, define si alguna opción está seleccionada por defecto
    }));

    const alert = await this.alertCtr.create({
      header: 'Selecciona un motivo de contacto',
      inputs: inputs,
      buttons: [
        {
          text: 'Cerrar Ventana',
          role: 'cancel',
          handler: () => {
            console.log('Ventana cerrada');
          }
        },
        {
          text: 'Enviar por E-mail',
          handler: (selectedMotivo) => {
            if (selectedMotivo) {
              this.motivoSeleccionado = selectedMotivo;
              this.continuarEnCorreo();
            } else {
              alert.message = 'Por favor, selecciona un motivo de contacto.';
              return false;
            }
          }
        },
        {
          text: 'Continuar en WhatsApp',
          handler: (selectedMotivo) => {
            if (selectedMotivo) {
              this.motivoSeleccionado = selectedMotivo;
              this.continuarEnWhatsApp();
            } else {
              alert.message = 'Por favor, selecciona un motivo de contacto.';
              return false;
            }
          }
        }

      ]
    });

    await alert.present();
  }

  continuarEnCorreo() {
    console.log('App -> Continuar por correo');
    if (this.authDispositivo?.usuario_auth) {
      if (this.authDispositivo.usuario_auth?.usuario) {
        this.redatwater.sendCorreoEmpresa(this.authDispositivo.usuario_auth?.empresa_data.empresa_id,
          this.motivoSeleccionado,
          this.authDispositivo.usuario_auth?.nombre,
          this.authDispositivo.usuario_auth?.codigo,
          this.authDispositivo.usuario_auth?.usuario).then((getData: any) => {
            if (getData) {
              console.log('Datos respuesta: ', getData);
              this.ventanaAlerta.msgAppCenter('AT WATER', '<span class="text-success">Hé procesado tu solicitud y enviado con éxito un correo con los detalles de tu asesoría</span>');
              this.aquaBot = this.aquabot.appMsgAquaBot({
                msg: 'Hé procesado tu solicitud y enviado con éxito un correo con los detalles de tu asesoría',
                estado: 'text-success',
                guia_referencia: '',
                estado_animado: '',
                objeto_animado: {
                  cabeza: '',
                  ojos: 'eye-casual',
                  ojos_pupila: 'pupil-casual',
                  boca: 'mouth-casual',
                  cuerpo: 'body-casual',
                  nucleo: 'energy',
                  brazos: {
                    der: 'limb-left-casual',
                    izq: 'limb-right-casual'
                  }
                },
                estado_entorno: '',
                entorno_animado: null
              });
              this.textSpeech.hablar('Hé procesado tu solicitud y enviado con éxito un correo con los detalles de tu asesoría');

            } else {
              console.log('Oops! Respuesta -> ', getData);
            }
          }).catch((err: any) => {
            console.log('Error: Enviar por correo ->', err);
          });
      }
    }
  }

  continuarEnWhatsApp() {
    if (this.authDispositivo?.usuario_auth) {
      if (this.authDispositivo.usuario_auth?.empresa_data) {
        const numeroWhatsApp = this.authDispositivo.usuario_auth?.empresa_data.empresa_whatsapp; // Cambiar por el número de WhatsApp
        const mensaje = encodeURIComponent(
          `Hola, me llamo ${this.authDispositivo.usuario_auth?.nombre}, Estoy en la App AT WATER y quiero recibir ayuda sobre: ${this.motivoSeleccionado}. \n Mis datos son: \n Número de cuenta: ${this.authDispositivo.usuario_auth?.codigo}, \n Modulo: ${this.authDispositivo.usuario_auth?.usuario} `
        );
        const enlace = `https://wa.me/${numeroWhatsApp}?text=${mensaje}`;
        window.open(enlace, '_blank');
      }
    }
  }

  /* Crear cuenta */
  navCrearCuentaApp(tipo: string) {
    if (tipo === 'referido') {
      // get_rec?tr=ref&pi=1&co_ref=20580643

      let urlReferido = this.redatwater.getWebUrl() + '/' + this.idiomaSeleccionado + '/homepage/get_rec?tr=ref&pi=' + this.paisSeleccionado?.id + '&co_ref=' + this.authDispositivo?.usuario_auth.codigo;
      console.log('Enlace referido: ', urlReferido);
      this.aquabot.enlaceSugerido(urlReferido, 'portal transaccional');

    } else {
      this.navRegistroApp();
    }

  }

  /* Nav Como funciona? */
  navComoFunciona() {
    this.menu.close('custom');
    if (this.videoComofunciona) {
      console.log('Video -> ', this.videoComofunciona);
      this.aquabot.enlaceSugerido(this.videoComofunciona, 'youtube');
    } else {
      console.log('Seguimiento de errores -> ', this.videoComofunciona);
    }
  }

  /* Nav Cambiar de idioma */
  navCambiarIdioma() {
    this.menu.close('custom');
    this.cambiarIdioma();
  }

  /* Nav Cajeros de agua */
  async navCajerosCercanos() {
    this.menu.close('custom');
    this.getCajerosCercanos();
  }

  /* Nav Portal transaccional */
  navPortalTransaccional() {
    this.menu.close('custom');
    this.aquabot.enlaceSugerido(this.redatwater.getWebUrl() + '/' + this.idiomaSeleccionado + '/homepage/auth', 'portal transaccional');
  }

  /* Nav Cerrar sesion */
  navCerrarSesion() {
    this.menu.close('custom');
    this.confirmarSalir();
  }

  /* Nav Terminos */
  navTerminos() {
    this.menu.close('custom');
    this.terminos_web();
  }

  /* Web oficial */
  webOficial() {
    this.menu.close('custom');
    this.aquabot.enlaceSugerido(this.redatwater.getWebUrl() + '/' + this.idiomaSeleccionado + '/homepage', 'sitio oficial');
  }

  async navApadrinamiento() {
    const modal = await this.modalController.create({
      component: ApadrinamientoModalComponent,
    });
    await modal.present();
  }

  // OTROS **************************************************************
  async establecerUbicacion() {
    this.appUbicacion.getUbicacionGPS().then((res) => {
      // console.log('Seguimiento -> Ubicacion Actual()', res);
      if (res) {
        this.ubicacion.lat = res.lat;
        this.ubicacion.lng = res.lng;
        this.ubicacion.direccion = res.direccion;
      }
    }).catch((err: any) => {
      this.ventanaAlerta.msgAppCenter('AT-WATER', 'Activa el GPS para establecer ubicación.');
      console.log('Seguimiento de errores -> ', err);
    });
  }

  async initializeApp() {
    try {
      this.establecerUbicacion();
      if (this.platform.is('capacitor')) { // ¿Movile?
        await SplashScreen.hide();
        if (this.platform.is('android')) {
          StatusBar.setBackgroundColor({ color: '#CDCDCD' });
        }
        this.insomnia.keepAwake().then(() => {
          console.log('Seguimiento -> Bloquedo de Pantalla: ****** Activo ******');
        }).catch(err => {
          console.log('Seguimiento de errores -> Bloquedo de Pantalla: ', err);
        });

        await StatusBar.setStyle({ style: Style.Light });

      }
    } catch (error) {
      console.log('Seguimiento -> Ejecutando App Web.... ', error);
    }
  }

  async cambiarIdioma() {
    console.log('Cambiar de idioma');
    this.listaIdiomas();
  }

  async listaIdiomas() {

    console.log('Seleccionar idioma: ');

    const alert = await this.alertCtr.create({
      cssClass: 'my-custom-class',
      header: '',
      inputs: [
        {
          label: 'Spanish',
          type: 'radio',
          name: 'idioma',
          value: 'es',
        },
        {
          label: 'English',
          type: 'radio',
          name: 'idioma',
          value: 'en',
        },
      ],
      buttons: [
        {
          text: 'Cerrar ventana',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Cerrar!');
          }
        }, {
          text: 'Aceptar',
          handler: (data) => {
            console.log('Idioma seleccionado -> ', data);
            if (data) {
              console.log('Ok!');
              this.seleccionarIdioma(data);
            }
          }
        }
      ]
    });

    await alert.present();

  }

  async terminos_web() {
    console.log('Navegador -> Portal Transaccional: Terminos y condiciones');
    this.aquabot.enlaceSugerido(this.redatwater.getWebUrl() + '/' + this.idiomaSeleccionado + '/homepage/terminosycondiciones', 'portal transaccional');
  }

  async getCajerosCercanos() {
    console.log('Seguimiento -> Consultar cajeros cercanos. ');
    const channelApp = this.channelApp;

    const modalAdd = await this.modalController.create({
      component: AppCajerosAguaComponent,
      mode: 'ios',
      swipeToClose: true,
      componentProps: { channelApp }
    });
    await modalAdd.present();
    const { data } = await modalAdd.onWillDismiss();
    if (data) {
      console.log('Seguimiento -> Data de Cajeros cerca: ', data);

    }
  }



  viewGuiRapida(usuario: string, tipo: string, grupo?: string) {
    console.log('Guia Rapida -> ', usuario, tipo, grupo);
    this.ventanaGuiaRapida(usuario, tipo, grupo);
  }



  async ventanaGuiaRapida(usuario: string, tipo: string, grupo_usuario: string) { // Publi Aqua Youtube

    const modalAdd = await this.modalController.create({
      component: AppGuiarapidaComponent,
      mode: 'ios',
      swipeToClose: true,
      componentProps: { usuario, tipo, grupo_usuario }
    });
    await modalAdd.present();
    const { data } = await modalAdd.onWillDismiss();
    if (data) {
      console.log('Finalizar datos -> ' + data);
    }
  }


  navAjustesApp() {
    console.log('Seguimiento -> App Usabilidad');
    this.menu.close('custom');
    this.ventanaAppUsabilidad();
  }

  async ventanaAppUsabilidad() { // Ajustes de usabilidad
    const modalAdd = await this.modalController.create({
      component: AppUsabilidadComponent,
      mode: 'ios',
      swipeToClose: true,
      componentProps: {}
    });
    await modalAdd.present();
    const { data } = await modalAdd.onWillDismiss();
    this.appUsabilidad.establecerFontSize();
    if (data) {
      console.log('Finalizar datos -> ' + data.direccion);

    }
  }

  navRegistroApp() {
    console.log('Seguimiento -> App Usabilidad');
    this.menu.close('custom');
    this.ventanaAppRegistro();
  }

  async ventanaAppRegistro() { // Formulario de registro App
    const modalAdd = await this.modalController.create({
      component: AppRegistroComponent,
      mode: 'ios',
      swipeToClose: true,
      componentProps: {}
    });
    await modalAdd.present();
    const { data } = await modalAdd.onWillDismiss();
    this.appUsabilidad.establecerFontSize();
    if (data) {
      console.log('Finalizar datos -> ' + data.direccion);

    }
  }

  navHelp() {
    console.log('Menu -> Ayuda');
    this.menu.close('custom');
    this.viewHelp();
  }

  async viewHelp() {
    const modalAdd = await this.modalController.create({
      component: HelpComponent,
      mode: 'ios',
      swipeToClose: true,
      componentProps: {}
    });
    await modalAdd.present();
    const { data } = await modalAdd.onWillDismiss();
    if (data) {
      console.log('Finalizar datos -> ' + data);
    }
  }

  async confirmarSalir() {
    if (this.channelSistema?.id) {
      console.log('Seguimiento -> Salir de App');

      const alert = await this.alertCtr.create({
        cssClass: 'my-custom-class',
        header: 'AT-WATER',
        message: '<span class="text-success">¿Está seguro de cerrar sesión?</span> Ingresa tu número de celular o documento para confirmar.',
        inputs: [
          {
            name: 'codigoCuenta',
            type: 'text',
            placeholder: 'Escribe tu número',
            attributes: {
              autocomplete: 'off'
            }
          },
        ],
        buttons: [
          {
            text: 'Cerrar ventana',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              console.log('Cerrar!');
            },
          },
          {
            text: 'Aceptar',
            handler: (data) => {
              const codigoCuentaIngresado = data.codigoCuenta;

              // Validación del código de cuenta
              if (codigoCuentaIngresado) {

                this.redatwater.verificarModulosDisponibles(codigoCuentaIngresado).then((getDataAquahabiente: any) => {
                  if (getDataAquahabiente) {

                    if (getDataAquahabiente && Array.isArray(getDataAquahabiente)) {

                      console.log('Código de cuenta válido, cerrando sesión.');
                      this.navCtrl?.navigateRoot(['/app-salir']);

                    } else {
                      console.log('Seguimiento de errores -> ', getDataAquahabiente);
                      this.aquaBot = this.aquabot.appMsgAquaBot({
                        msg: this.itemsIdioma.aquaboot_msg_clave_registrar_parametros_cuenta,
                        estado: 'text-danger'
                      });
                    }

                  } else {
                    console.log('Seguimiento de errores -> ', getDataAquahabiente);
                    this.aquaBot = this.aquabot.appMsgAquaBot({
                      msg: this.itemsIdioma.aquaboot_msg_clave_registrar_consultarcuenta,
                      estado: 'text-danger'
                    });
                  }

                }).catch((err: any) => {
                  console.log('Seguimiento de errores -> ', err);
                });

              } else {
                // Si el código es incorrecto, muestra un error
                console.log('Código de cuenta incorrecto.');
                this.mostrarErrorCodigoCuenta(); // Función para mostrar un mensaje de error
              }
            },
          },
        ],
      });

      await alert.present();
    } else {
      console.log('Seguimiento de errores -> Parámetros salir', this.channelSistema);
    }
  }

  // Función para mostrar un mensaje de error cuando el código de cuenta es incorrecto
  mostrarErrorCodigoCuenta() {
    this.alertCtr.create({
      header: 'Error',
      message: 'El código de cuenta ingresado es incorrecto. Intente nuevamente.',
      buttons: ['OK'],
    }).then(alert => alert.present());
  }


  navConfirmarPedido() {
    console.log('Escanear y procesar pedido');
    this.escanearCodigo();
  }

  async escanearCodigo() {
    let metodosPermitidos = [];

    metodosPermitidos.push({
      label: this.itemsIdioma.escancer_opt_camara_frontal,
      type: 'radio',
      name: 'camara_metodo',
      value: false,
    });

    metodosPermitidos.push({
      label: this.itemsIdioma.escancer_opt_camara_back,
      type: 'radio',
      name: 'camara_metodo',
      value: true,
    });

    const alert = await this.alertCtr.create({
      cssClass: 'my-custom-class',
      header: this.itemsIdioma.escaner_titulo_camara,
      inputs: metodosPermitidos,
      buttons: [
        {
          text: this.itemsIdioma.modal_btn_cerrar,
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Cerrar!');
          }
        }, {
          text: this.itemsIdioma.modal_btn_aceptar,
          handler: (data: any) => {
            console.log('Ok!');

            if (data === true) {
              this.leerQrCuenta(data);
            } else if (data === false) {
              this.leerQrCuenta(data);
            } else {
              this.escanearCodigo();
            }
          }
        }
      ]
    });

    await alert.present();
  }

  async leerQrCuenta(camara: any) { // Escanear cuenta aquahabiente
    this.escaner.leerQr(camara).then((data: any) => {
      console.log('Seguimiento escaner -> ' + data);
      let parametrosEscaneados: any = data;

      if (parametrosEscaneados?.token &&
        parametrosEscaneados?.categoria &&
        parametrosEscaneados?.pedido_id &&
        parametrosEscaneados?.sistema_key) {

        if (this.escaner.verificarToken(parametrosEscaneados.token)) {

          if (parametrosEscaneados.categoria === 'pedido_domiciliario') {

            this.pedidoDomiciliario.sistema_key = parametrosEscaneados.sistema_key;
            this.pedidoDomiciliario.pedido_id = parametrosEscaneados.pedido_id;
            this.pedidoDomiciliario.encriptado = 1;

            console.log('Parametros escaneados Pedido -> ', JSON.stringify(this.pedidoDomiciliario));

            this.confirmarPedidoDomiciliario();

          } else {
            this.ventanaAlerta.msgAppCenter(this.itemsIdiomaApp.app_titulo_alertas, this.itemsIdioma.alertas_pedido_domiciliario_qr_caterogoria);
            console.log('Seguimiento de errores -> ¡Oops! No es la categoria');
          }

        } else {
          console.log('Seguimiento de errores -> ¡Oops! Token de lector QR denegado.');
        }

      } else {
        this.ventanaAlerta.msgAppCenter(this.itemsIdiomaApp.app_titulo_alertas, this.itemsIdioma.alertas_pedido_domiciliario_qr_parametros);
        console.log('Seguimiento de errores -> ¡Oops! Parametros escaneados ', parametrosEscaneados);
      }
    }).catch((err: any) => {
      console.log('Seguimiento de errores ->', err);
    });
  }


  async confirmarPedidoDomiciliario() {

    this.redatwater.confirmarPedidoDomiciliario(this.pedidoDomiciliario).then((getData: any) => {

      console.log('Seguimiento Pedido -> ', getData);

      if (getData) {

        this.ventanaAlerta.msgAppCenter(this.itemsIdiomaApp.app_titulo_alertas, '<span class="text-success">' + this.itemsIdioma.alertas_pedido_domiciliario_confirmado + '</span>');

      } else {
        console.log('Seguimiento de errores: pedido -> ', getData);
      }

    }).catch((err: any) => {
      console.log('Seguimiento de errores: pedido -> ', err);
    });

  }

  navTemasInteres() {
    console.log('Seguimiento -> Nav Temas de Interes.');
    this.ventanaTemasIntereses();
  }

  async ventanaTemasIntereses() { // Ok PEDIDO
    console.log('Ventana -> Temas de interes!');
    const modalAdd = await this.modalController.create({
      component: AppInteresComponent,
      mode: 'ios',
      swipeToClose: true,
      componentProps: {}
    });
    await modalAdd.present();
    const { data } = await modalAdd.onWillDismiss();

    if (data) {
      console.log('Finalizar datos -> ' + data);
    }
  }

  navPubliaqua() {
    console.log('Anuncios Youtube');
    this.viewPubliAquaYoutube();
  }

  async viewPubliAquaYoutube() { // Publi Aqua Youtube
    const modalAdd = await this.modalController.create({
      component: AppPubliaquaYoutubeComponent,
      mode: 'ios',
      swipeToClose: true,
      componentProps: {}
    });
    await modalAdd.present();
    const { data } = await modalAdd.onWillDismiss();
    if (data) {
      console.log('Finalizar datos -> ' + data);
    }
  }

  async recargarWebView() {
    this.programarRecarga(3600000); // 1 hora
  }

  private programarRecarga(tiempo: number) {
    if (this.reloadIntervalId) {
      clearInterval(this.reloadIntervalId);
      this.reloadIntervalId = null;
    }

    this.reloadIntervalId = setInterval(() => {
      this.promptBeforeReload();
    }, tiempo);
  }

  private async promptBeforeReload() {
    // ✅ Si ya hay un prompt activo, no hacer nada
    if (this.isPromptActive) return;

    this.isPromptActive = true;

    const alert = await this.alertCtr.create({
      header: '¡Atención! ⚡️',
      message: `
      Para mantener tu experiencia fluida y evitar que la app se vuelva lenta, 
      es importante recargarla ahora.
      <strong>¿Deseas detener la recarga automática?</strong>
    `,
      backdropDismiss: false,
      buttons: [
        {
          text: 'No, recárgala ahora',
          handler: () => {
            clearTimeout(this.timeoutId);
            this.isPromptActive = false;
            this.doReload();
          },
        },
        {
          text: 'Sí, detén la recarga',
          role: 'cancel',
          handler: () => {
            clearTimeout(this.timeoutId);
            this.isPromptActive = false;
            console.log('⏱ Recarga pospuesta 3 horas por decisión del usuario.');
            this.programarRecarga(3 * 3600000); // 3 horas
          },
        },
      ],
    });

    await alert.present();

    // ✅ Auto cierre en 6 segundos si no responde
    this.timeoutId = setTimeout(async () => {
      if (this.isPromptActive) {
        await alert.dismiss();
        this.isPromptActive = false;
        this.doReload();
      }
    }, 6000);
  }

  private doReload() {
    console.log('Recargando app… 🌐🔄');
    window.location.reload();
  }

  navAppWaterclientes() {
    this.aquabot.enlaceSugerido('https://bancodelagua.com/app/es/homepage/descargarAppPlaystore?tipo_app=bancodelagua', 'App WATER Cliente');
  }
}
